'use client';

import { ReactNode } from 'react';
import { useRouter } from 'next/navigation';
import { SWRConfig } from 'swr';
import Bugsnag from '@bugsnag/js';
import { z } from 'zod';
import { UnauthenticatedError } from './UnauthenticatedError';

const serverErrorSchema = z.object({
  type: z.string().optional(),
  status: z.string().optional(),
  title: z.string(),
  detail: z.string().optional(),
});

export type ServerErrorObject = z.infer<typeof serverErrorSchema>;

export class ServerError extends Error {
  constructor(init: unknown) {
    super();

    this.error = serverErrorSchema.parse(init);
    this.message = this.error.detail ?? '';
  }

  error: ServerErrorObject = {
    title: '',
  };
}

export default function ServerErrorWrapper({
  children,
}: {
  children: ReactNode;
}) {
  const { push } = useRouter();

  return (
    <SWRConfig
      value={{
        onError: (error) => {
          if (error instanceof UnauthenticatedError) {
            push('/logout');
          }

          if (error instanceof ServerError) {
            return;
          }

          if (error.status !== 401) {
            Bugsnag.notify(new Error(error));
          }
        },
      }}
    >
      {children}
    </SWRConfig>
  );
}
